/**
 * Resolve contest logo image URL for display.
 * Strapi often returns relative paths (e.g. /uploads/...) that need the API base URL.
 */
export function getContestLogoUrl(logo) {
  if (!logo?.image) return null
  const { publicURL, url } = logo.image
  if (publicURL) return publicURL
  if (url) {
    if (url.startsWith("http")) return url
    const base = (process.env.GATSBY_API_URL || "").replace(/\/$/, "")
    const path = url.startsWith("/") ? url : `/${url}`
    return base ? `${base}${path}` : url
  }
  return null
}
